import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { ReactNode, useContext } from "react";
import { SpinContext } from "./spin.context";

export interface CustomSpinProps {
  children: ReactNode;
}

function CustomSpin(props: CustomSpinProps) {
  const { state } = useContext(SpinContext);

  return (
    <Spin
      style={{
        display: 'flex',
        flexGrow: 1
      }}
      indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
      spinning={state.blocked}
      size="large"
    >
      {props.children}
    </Spin>
  );
}

export default CustomSpin;
